import FilterThemes from "./components/FilterThemes";
import SortThemes from "./components/SortThemes";
import ThemeGrid from "./components/ThemeGrid";
import ThemePaginationInfo from "./components/ThemePaginationInfo";

const Marketplace = () => {
  return (
    <div className="mb-[1em] px-[0.5em] py-[0.5em] flex flex-row gap-[1em] border bg-white rounded-t-xl">
      <div></div>
      <div></div>
    </div>
  );
};

export default Marketplace;
